import { Box } from "arkh";
import React, { PropsWithChildren } from "react";
import { Platform, Modal, Pressable, StyleSheet, View } from "react-native";

function Wrapper(props: {
  children: React.ReactNode | undefined;
  onRequestClose: () => void;
}) {
  const width = 455;
  const height = 230;

  if (Platform.OS !== "web") return <>{props.children}</>;

  return (
    <Box
      space="large"
      style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
    >
      <Pressable
        style={[StyleSheet.absoluteFill]}
        onPress={() => {
          props.onRequestClose();
        }}
      >
        <View
          style={[
            StyleSheet.absoluteFill,
            {
              backdropFilter: "blur(1.6px)",
              background: "rgba(0,0,0,0.1)",
            } as any,
          ]}
        />
      </Pressable>
      <Box
        cornerRadius="large"
        shadow="medium"
        color="surface"
        style={{
          position: "absolute",
          width: width,
          minHeight: height,
          overflow: "hidden",
        }}
      >
        {props.children}
      </Box>
    </Box>
  );
}

export function WebPopup(
  props: PropsWithChildren<{
    onDismiss: () => void;
  }>
) {
  return (
    <Modal
      visible={!!props.children}
      transparent
      presentationStyle="overFullScreen"
      animationType="fade"
      style={{ flex: 1 }}
      onRequestClose={props.onDismiss}
    >
      {props.children ? (
        <Wrapper onRequestClose={props.onDismiss}>
          <Box space="large" style={{ flex: 1 }}>
            {props.children}
          </Box>
        </Wrapper>
      ) : null}
    </Modal>
  );
}
